import RxGoogleMap from '../map/RxGoogleMap';

const mapLayers = [
  {
    id: 'fungicide-headline',
    name: 'Fungicide - Headline AMP®',
    visible: true,
  },
  {
    id: 'fungicide-priaxor',
    name: 'Fungicide - Priaxor®',
    visible: true,
  },
  {
    id: 'fungicide-trivapro',
    name: 'Fungicide - Trivapro®',
    visible: true,
  },
  {
    id: 'fungicide-delaro',
    name: 'Fungicide - Delaro® Complete',
    visible: true,
  },
  {
    id: 'fungicide-aproach-prima',
    name: 'Fungicide - Aproach® Prima',
    visible: true,
  },
  {
    id: 'fungicide-other',
    name: 'Fungicide - Other',
    visible: true,
  },
];

export default function EarlySeasonFungicideMap() {
  return <RxGoogleMap layers={mapLayers} />;
}
